import { CmsGuestCheckout } from '../../models/cms/cms-guest-checkout.interface';

export const mockCmsGuestCheckout: CmsGuestCheckout = {
  guestCheckoutButtonLabel: 'guestCheckoutButtonLabel',
  guestCheckoutDescription: 'guestCheckoutDescription',
  guestCheckoutTitle: 'guestCheckoutTitle',
};
